import module from "./Header.module.css";
import { Button } from "@mui/material";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RightDrawer from "./RightDrawer";
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";

const styles = {
  loginParam: css`
    font-weight: bold;
  `,
};

const logoCenterPathList = ["/login", "/login/", "/signup", "/signup/"];

export default function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(false);
  const isLogoCenter = logoCenterPathList.some(
    (path) => location.pathname === path
  );

  const getUser = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setIsLogin(true);
    } catch (e) {
      setIsLogin(false);
      const isMypage = location.pathname.includes("/mypage");
      if (isMypage) {
        navigate("/login");
      }
    }
  };

  useEffect(() => {
    getUser();
  }, [location]);

  const handleClickLogo = () => {
    if (isLogin) {
      navigate("/mypage/accounts");
      return null;
    }
    navigate("/");
  };

  const SideMenu = () => {
    if (isLogin) {
      return <RightDrawer />;
    }
    if (isLogoCenter) {
      return null;
    }
    return (
      <Button
        color="secondary"
        css={styles.loginParam}
        LinkComponent={Link}
        to="login"
      >
        ログインする
      </Button>
    );
  };

  return (
    <div className={module.container}>
      <p
        className={
          isLogoCenter
            ? `${module.wrapImage} ${module.imageToCenter}`
            : module.wrapImage
        }
      >
        <img
          src={process.env.PUBLIC_URL + "/noshLogo.svg"}
          alt="nosh"
          className={module.logo}
          onClick={handleClickLogo}
        />
      </p>
      <div className={module.wrapLoginParam}>
        <SideMenu />
      </div>
    </div>
  );
}
